import * as React from 'react';
import { Bar, BarChart as RechartsBarChart, Legend, Tooltip, XAxis, YAxis } from 'recharts';
import { Row } from 'gossamer-unified';
import { SubSectionMultiProps } from 'gossamer-front-end';

const COLOUR_SEQUENCE = ['#6f1926', '#de324c', '#f4895f', '#f8e16f', '#95cf92', '#369acc', '#9656a2', '#cbabd1'];

interface BarChartProps<T extends Row> extends SubSectionMultiProps<T> {
  height?: number;
  width?: number;
  lineFields: string[];
  xAxisField: string;
  xAxisTickFormatter?: (value: string) => string;
  yAxisAllowDecimals?: boolean;
}

export const BarChart = <T extends Row>(props: BarChartProps<T>): React.JSX.Element | null => {
  return (
    <RechartsBarChart width={props.width ?? 500} height={props.height ?? 300} data={props.rows}>
      {props.lineFields.map((line) => (
        <Bar
          dataKey={line}
          key={line}
          name={props.entity.fields[line as keyof T]?.label}
          fill={COLOUR_SEQUENCE[props.lineFields.indexOf(line) % COLOUR_SEQUENCE.length]}
          radius={[5, 5, 0, 0]}
        />
      ))}
      <XAxis dataKey={props.xAxisField} tickFormatter={props.xAxisTickFormatter} />
      <YAxis allowDecimals={typeof props.yAxisAllowDecimals === 'boolean' ? props.yAxisAllowDecimals : true} />
      <Legend itemSorter={null} />
      {/* <Tooltip separator=": " /> - causes a grey overlay block over the whole hovered group of columns for some reason */}
    </RechartsBarChart>
  );
};
